import { getCookie, setCookie } from "../../../helper/cookie-storage";
import { isProd } from "../../../utilities/enviroments";

export enum OneTrustCookie {
  StrictlyNecessary = "C0001",
  Performance = "C0002",
  Functional = "C0003",
  Targeting = "C0004",
}

export const ONE_TRUST_CUSTOM_COOKIE_NAME = "optanoncustomconsentprovider";
export const NATIVE_ONE_TRUST_COOKIE_NAME = "OptanonConsent";

export function insertOneTrustBanner(src: string, dataDomain: string) {
  const head = document.querySelector("head");

  const script = document.createElement("script");
  script.setAttribute("data-domain-script", dataDomain);
  script.setAttribute("data-document-language", isProd() ? "true" : "false");
  script.setAttribute("type", "text/javascript");
  script.setAttribute("charset", "UTF-8");
  script.setAttribute("id", "_oneTrustCookieBannerScriptId");
  script.setAttribute("src", src);

  const script2 = document.createElement("script");
  script2.setAttribute("type", "text/javascript");
  script2.text = `function OptanonWrapper() { window.OneTrust.OnConsentChanged((e) => window.setOptanoncustomconsentprovider(e)); }`;

  (window as any).setOptanoncustomconsentprovider = setOptanoncustomconsentprovider;

  // Ensure the script is the first one in the head
  if (head?.firstChild) {
    head.insertBefore(script2, head.firstChild);
    head.insertBefore(script, head.firstChild);
  } else {
    head?.appendChild(script);
    head?.appendChild(script2);
  }
}

function setOptanoncustomconsentprovider(e: any) {
  const accpetedCookies = (e?.detail as string[])?.join(",");
  if (!accpetedCookies) return;
  const encodedAccpetedCookies = btoa(accpetedCookies);
  if (!encodedAccpetedCookies) return;
  setCookie(ONE_TRUST_CUSTOM_COOKIE_NAME, encodedAccpetedCookies);
  // Reload the page to trigger all the tracking events that depends on this one
  window.location.reload();
}

function extractGroups(consentCookie: string): string | null {
  const decoded = decodeURIComponent(consentCookie);
  const params = new URLSearchParams(decoded);
  const raw = params.get("groups");
  if (!raw) return null;
  return raw;
}

export function parseOneTrustCategoryFlags(decoded: string): Record<string, boolean> {
  const map: Record<string, boolean> = {};

  if (!decoded) return map;

  const pairs = decoded.split(",");

  for (const pair of pairs) {
    const [codeRaw, valueRaw] = pair.split(":");

    if (!codeRaw || !valueRaw) continue;
    const code = codeRaw.trim();
    const value = valueRaw.trim();

    // Accept only codes like C0001 and values 0 or 1
    if (/^C\d{4}$/.test(code) && (value === "0" || value === "1")) {
      map[code] = value === "1";
    }
  }

  return map;
}

export function requiredCookiesAccepted(requiredCookies: OneTrustCookie[]): boolean {
  const consentCookie = getCookie(ONE_TRUST_CUSTOM_COOKIE_NAME);
  if (consentCookie) {
    // Decode the OptanonConsent value
    const decodedConsentValue = atob(consentCookie);

    // Check if some of the required cookies are included
    return requiredCookies.some((cookie) => decodedConsentValue.includes(cookie));
  } else {
    const consentNativeCookie = getCookie(NATIVE_ONE_TRUST_COOKIE_NAME);
    if (!consentNativeCookie) return false;

    const groups = extractGroups(consentNativeCookie);
    if (!groups) return false;

    // groups now looks like: "C0001:1,C0002:1,C0003:1,C0004:1"
    const flags = parseOneTrustCategoryFlags(groups);
    return requiredCookies.some((code) => flags[code] === true);
  }
}
